import React, { useMemo } from 'react'
import { tokens } from '../../../styles/desertFloraTheme'

const dotColors = {
  danger: '#a9341d',
  warn: '#8c5b00',
  info: tokens.ink3
}

const ValidationPanel = ({ projectService, projectServices }) => {
  const items = useMemo(() => {
    const result = []
    if (!projectService) return result

    const components = projectService.components || []
    const hasComponents = components.length > 0

    // Danger: missing quantity
    if (projectService.totalQuantity === 0 && hasComponents) {
      result.push({
        level: 'danger',
        name: 'Missing quantity',
        description: 'Set the service quantity'
      })
    }

    // Danger: labor rate missing
    components.forEach((c) => {
      if (c.costType === 'labor' && !c.productionRate) {
        result.push({
          level: 'danger',
          name: 'Labor rate missing',
          description: c.description || 'Unnamed component'
        })
      }
    })

    // Warn: material unassigned
    components.forEach((c) => {
      if (c.costType === 'material' && !c.materialPricing?.catalogItemId) {
        result.push({
          level: 'warn',
          name: 'Material unassigned',
          description: c.description || 'Unnamed component'
        })
      }
    })

    // Warn: no cost calculated
    if (projectService.totalCost === 0 && hasComponents) {
      result.push({
        level: 'warn',
        name: 'No cost calculated',
        description: 'Check rates and quantities'
      })
    }

    // Info: project-level services needing pricing
    if (projectServices && projectServices.length > 0) {
      const unpricedCount = projectServices.filter(ps => ps.totalSell === 0).length
      if (unpricedCount > 0) {
        result.push({
          level: 'info',
          name: `${unpricedCount} service${unpricedCount === 1 ? '' : 's'} need pricing`,
          description: 'Project-level'
        })
      }
    }

    return result
  }, [projectService, projectServices])

  const warnCount = items.filter(i => i.level === 'danger' || i.level === 'warn').length

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <div style={{
          fontFamily: tokens.fontMono, fontSize: 10.5, fontWeight: 600,
          letterSpacing: '.12em', textTransform: 'uppercase', color: tokens.ink3
        }}>
          Needs attention
        </div>
        {warnCount > 0 && (
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 4,
            background: '#fff3d9', color: '#8c5b00',
            fontFamily: tokens.fontMono, fontSize: 10,
            padding: '1px 6px', borderRadius: 999,
            border: '1px solid currentColor'
          }}>
            <span style={{
              width: 5, height: 5, borderRadius: '50%',
              background: 'currentColor', flexShrink: 0
            }} />
            {warnCount}
          </span>
        )}
      </div>

      {items.length === 0 ? (
        <div style={{ fontSize: 12, color: tokens.ink4, fontStyle: 'italic' }}>
          No issues found.
        </div>
      ) : (
        items.map((item, idx) => (
          <div
            key={idx}
            style={{
              display: 'flex', gap: 8, padding: '8px 0',
              borderBottom: idx < items.length - 1 ? `1px dashed ${tokens.line}` : 'none'
            }}
          >
            <span style={{
              width: 6, height: 6, borderRadius: '50%',
              background: dotColors[item.level],
              flexShrink: 0, marginTop: 5
            }} />
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: tokens.ink }}>
                {item.name}
              </div>
              <div style={{ fontSize: 11, color: tokens.ink3 }}>
                {item.description}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  )
}

export default ValidationPanel
